import React from 'react';
import { SwipeableDrawer } from '@material-ui/core';
import { ChevronLeft } from "../../icons";
import { CloseButton } from "../CloseButton/CloseButton";
import { IconButton } from "../IconButton";
import styles from "./BottomSheet.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BottomSheet(props) {
  const {
    open,
    onClose,
    onOpen,
    children,
    showBackButton,
    onBack
  } = props;
  return /*#__PURE__*/_jsx(SwipeableDrawer, {
    disableDiscovery: true,
    disableSwipeToOpen: true,
    anchor: "bottom",
    open: open,
    onClose: onClose,
    onOpen: onOpen,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.root,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.header,
        children: [showBackButton && /*#__PURE__*/_jsx("div", {
          className: styles.backButton,
          children: /*#__PURE__*/_jsx(IconButton, {
            onClick: onBack,
            size: "medium",
            children: /*#__PURE__*/_jsx(ChevronLeft, {})
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.swipeIndicator
        }), /*#__PURE__*/_jsx(CloseButton, {
          className: styles.closeButton,
          size: "medium",
          onClick: onClose
        })]
      }), children]
    })
  });
}